import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteTablePayload } from '@app-store/slices/table/delete'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IDeleteTablePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.table.delete

function* deleteTableSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.delete(`/meeting/table/${payload.tableId}`)
        if (response.success) {
            yield put(onSuccess({ response: response.result, tableId: payload.tableId }))
            if (payload?.sagaCB) {
                payload.sagaCB.onSuccess()
            }
            notification.success({
                message: 'Table deleted successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure({ error, tableId: payload.tableId }))
    }
}

function* deleteTableSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteTableSagaTask)
}

export default deleteTableSaga
